import {languageProcessing} from '@axyseo/index.js';
const {AbstractResearcher} = languageProcessing;

// All helpers
import matchWordCustomHelper from './helpers/matchTextWithWord';
import splitIntoTokensCustom from './helpers/splitIntoTokensCustom';
import getSentencesCustom from './helpers/getSentences';

// All config
import {all as functionWords} from './config/functionWords';

/**
 * The researcher contains all the researches, helpers, data, and config for Chinese language.
 */
export default class Researcher extends AbstractResearcher {
  /**
   * Constructor
   * @param {Paper} paper The Paper object that is needed within the researches.
   * @constructor
   */
  constructor(paper) {
    super(paper);

    // Delete researches that are not suitable for Chinese
    delete this.defaultResearches.getFleschReadingScore;

    Object.assign(this.config, {
      language: 'zh',
      functionWords,
      // Chinese doesn't use hyphens as word boundaries
      areHyphensWordBoundaries: false
    });

    Object.assign(this.helpers, {
      matchWordCustomHelper,
      splitIntoTokensCustom,
      getSentencesCustom
    });
  }
}
